export const CONTACT_EMAIL = 'mundertruckingllc@yahoo.com';
export const CONTACT_PHONE = '(541) 720-0949';
export const CONTACT_FORM_NAME = 'contact';
